import { siteConfig } from '../data';
import { ExternalLink, FileText } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#103B66] py-10 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12">
          <div>
            <img 
              src="https://assets.auxodev.dk/assets/2cadb5d8-c2c5-4850-ae22-0167799adce5/68ad25eb-0941-4382-bc74-28af4d9d30b4.png" 
              alt="Online Tryghed Logo" 
              className="h-12 w-auto object-contain brightness-0 invert mb-6"
            />
            <p className="text-white/90 text-base leading-relaxed">
              Vi skaber tryghed på nettet for ældre og sårbare borgere gennem personlig, tålmodig og professionel hjælp.
            </p>
          </div>
          
          <div className="flex flex-col">
            <h4 className="font-bold text-white mb-4 text-lg">Virksomhed</h4>
            <ul className="space-y-3 text-white/80 text-base">
              <li>Online Tryghed ApS</li>
              <li>Fruegade 42B</li>
              <li>4200 Slagelse</li>
              <li>
                <a 
                  href="https://datacvr.virk.dk/enhed/virksomhed/43341758?fritekst=online%2520trvehed%2520aps&sidelndex=08.size=10" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 hover:text-white transition-colors"
                >
                  CVR: 43341758
                  <ExternalLink className="w-4 h-4 text-white/60" />
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col">
            <h4 className="font-bold text-white mb-4 text-lg">Kontakt</h4>
            <ul className="space-y-3 text-white/80 text-base">
              <li>Tlf: {siteConfig.phone}</li>
              <li>SMS: {siteConfig.sms}</li>
              <li>Email: {siteConfig.email}</li>
            </ul>
          </div>

          <div className="flex flex-col">
            <h4 className="font-bold text-white mb-4 text-lg">Åbningstider</h4>
            <ul className="space-y-3 text-white/80 text-base">
              <li>{siteConfig.hours}</li>
              <li className="text-sm text-white/70 leading-relaxed">
                Vi holder lukket på alle officielle helligdage, men det er altid muligt at sende os en SMS.
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-6 text-sm text-white/60">
          <p>© {new Date().getFullYear()} Online Tryghed. Alle rettigheder forbeholdes.</p>
          <div className="flex flex-wrap items-center gap-6">
            <a 
              href="/_assets/forretningsbetingelser-for-online-tryghed-aps.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-white/70 hover:text-white transition-colors underline-offset-4 hover:underline"
            >
              <FileText className="w-4 h-4 text-white/60" />
              <span>Forretningsbetingelser (PDF)</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
